export default "__VITE_ASSET__34BI41F___"